





















import Vue from 'vue'
import radio from '@/components/controls/radio/radio.vue'
import style from './style.module.scss'

export default Vue.extend({
name: 'organization-type',
  components: {
    radio
  },
  props: {
    value: Boolean
  },
  data() {
    return {
    s: style
    }
  },
})
